import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const newConsumerFormValidation = getFormValidator(
  object().shape({
    name: string().optional(),
  }),
);
